import { IApiErrorResponse } from '@/models'

export function getOrderCodeError(
    error: IApiErrorResponse,
    orderNumber: string
): IApiErrorResponse {
    if (error.data.errorDetails?.wooStatus === 'on-hold') {
        error.data.errorText = `Płatność za zamówienie nr ${orderNumber} jest w trakcie przetwarzania. Zamówienie dostawy będzie możliwe po pozytywnym zakończeniu płatności. Poinformujemy Cię o tym mailowo.`

        return error
    }

    return error
}
